import React, { useState, useEffect, useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { OrganizationContext } from "../../../Services/OrganizationContext";
import authService from "../../../Services/authService";
import { Button } from "antd";
import Trash from "../../Assets/images/recycle-bin.png";
import Plus from "../../Assets/images/plus.png";
import TabMenu from "./TabMenu";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const HistoryLabUploadFile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { organization } = useContext(OrganizationContext);
  const [AddMoreFiles, setAddMoreFiles] = useState([{ id: Date.now() }]); // Track file upload fields
  const [AddMoreFilesLab, setAddMoreFilesLab] = useState([{ id: Date.now() }]); // Track file upload fields
  const [files, setFiles] = useState([]); // Track uploaded files
  const [filesLab, setFilesLab] = useState([]); // Track uploaded files

  const [OrderInf, setData] = useState({});
  const [formData, setFormData] = useState({
    package_name: "",
    description: "",
    price: "",
    organization_id: organization?.id || "",
    Is_Active: "",
  });

  useEffect(() => {
    if (organization) {
      loadOrdersInfo();
    }
  }, [organization]); // ✅ Added dependency for optimization

  const loadOrdersInfo = async () => {
    try {
      const token = authService.getCurrentadmin()?.token; // ✅ Optional chaining to prevent errors

      if (!token) {
        console.error("No authentication token found");
        return;
      }

      const response = await fetch(`${authService.getApiUrl()}laboratorydetails`, {
        method: "POST",
        body: JSON.stringify({ order_id: id }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        authService.logout();
        window.location.href = "/admin";
      } else {
        const result = await response.json();
        setData(result?.data?.[0] || {}); // ✅ Directly extracts first object safely
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // const handleImageChange = (e, index) => {
  //   const newFiles = [...files];
  //   newFiles[index] = e.target.files[0];
  //   setFiles(newFiles);
  // };

  const handleAddTest = () => {
    setAddMoreFiles([...AddMoreFiles, { id: Date.now() }]);
  };

  const handleAddTestLab = () => {
    setAddMoreFilesLab([...AddMoreFilesLab, { id: Date.now() }]);
  };

  const handleRemoveTest = (index) => {
    setAddMoreFiles(AddMoreFiles.filter((_, i) => i !== index));
    setFiles(files.filter((_, i) => i !== index)); // Remove the corresponding file from state
  };

  const handleRemoveTestLab = (index) => {
    setAddMoreFilesLab(AddMoreFilesLab.filter((_, i) => i !== index));
    setFilesLab(filesLab.filter((_, i) => i !== index)); // Remove the corresponding file from state
  };

  const handleImageChange = (e, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const newFiles = [...files];
      newFiles[index] = selectedFile;
      setFiles(newFiles);
    }
    console.log("Selected Files:", files);
  };

  const handleImageChangeLab = (e, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const newFiles = [...filesLab];
      newFiles[index] = selectedFile;
      setFilesLab(newFiles);
    }
    console.log("Selected Files:", files);
  };

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        resolve(""); // Handle empty files
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleSubmit = async (event, visitTypeId) => {

    if (event && event.preventDefault) {
      event.preventDefault();
    }

    const token = authService.getCurrentadmin()?.token;
    if (!token) {
      console.error("No authentication token found");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("organization_id", organization);
      formData.append("order_id", id);
      formData.append("visit_type_id", visitTypeId);

      if (visitTypeId == 1) {
        files.forEach((file, index) => {
          if (file) {
            formData.append(`document_name[]`, file); // Send files correctly
          }
        });
      } else {
        filesLab.forEach((file, index) => {
          if (file) {
            formData.append(`document_name[]`, file); // Send files correctly
          }
        });
      }


      const response = await fetch(authService.getApiUrl() + "laboratoryupload", {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      console.log("Upload Response:", result);
      window.history.back();
    } catch (err) {
      console.error("Upload Error:", err.message);
    }
  };


  const openPDF = (fileUrl) => {
    window.open(fileUrl, "_blank");
  };

  const handleDeleteFile = (id) => {
    const token = authService.getCurrentadmin()?.token;
    fetch(authService.getApiUrl() + 'laboratoryreport/' + id, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result) {
          // ✅ Remove deleted file from state
          setData((prevData) => ({
            ...prevData,
            athome: prevData.athome.filter((file) => file.id !== id),
          }));
        } else {
          console.error("Failed to delete file:", result.message);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }


  const handleDeleteFileLab = (id) => {
    const token = authService.getCurrentadmin()?.token;
    fetch(authService.getApiUrl() + 'laboratoryreport/' + id, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result) {
          // ✅ Remove deleted file from state
          setData((prevData) => ({
            ...prevData,
            atlab: prevData.atlab.filter((file) => file.id !== id),
          }));
        } else {
          console.error("Failed to delete file:", result.message);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  const visitTypeIds = OrderInf?.visit_type?.map(v => v.visit_type_id) || [];
  return (
    <div className="main-container">
      <div className="container-fluid">
        <Breadcrumb />
        <TabMenu name="order-history" />
        <div className="category-table">
          <div className="flex-cont add-cat">
            <div className="heading">
              <h3>Update Order</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" >
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="full-cont">
                      <div className="user-table first-table">
                        <div className="user-role">
                          <table
                            key={OrderInf?.order_id}
                            border="1"
                            cellSpacing="0"
                            cellPadding="10"
                            style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}
                          >
                            <tbody>
                              {/* Always show Invoice Number */}
                              <tr>
                                <td colSpan="5">
                                  <strong>Invoice Number:</strong> {OrderInf?.invoice_number || "N/A"}
                                </td>
                              </tr>

                              {/* Show headers and product rows if tests exist */}
                              {OrderInf?.orders_items?.products?.length > 0 && (
                                <>
                                  <tr>
                                    <td><strong>Patient Name</strong></td>
                                    <td><strong>Test Name</strong></td>
                                    <td><strong>Quantity</strong></td>
                                    <td><strong>Preparation</strong></td>
                                    <td><strong>Visit Type</strong></td>
                                  </tr>
                                  {OrderInf.orders_items.products.map((items, index) => (
                                    <tr key={`product-${items.id || index}`}>
                                      <td>{items.family_member_name || "N/A"}</td>
                                      <td>{items.test_name || "N/A"}</td>
                                      <td>{items.quantity || "N/A"}</td>
                                      <td>{items.preparation || "N/A"}</td>
                                      <td>{items.visit_type || "N/A"}</td>
                                    </tr>
                                  ))}
                                </>
                              )}

                              {/* Show package details if packages exist */}
                              {OrderInf?.orders_items?.packages?.length > 0 && (
                                <>
                                  {OrderInf.orders_items.packages.map((pitems, index) => (
                                    <React.Fragment key={`package-${pitems.id || index}`}>
                                      <tr>
                                        <td colSpan="2">
                                          <strong>Package Name:</strong> {pitems.test_name || "N/A"}
                                        </td>
                                        <td colSpan="2">
                                          <strong>Patient Name:</strong> {pitems.family_member_name || "N/A"}
                                        </td>
                                        <td>{pitems.visit_type || "N/A"}</td>
                                      </tr>
                                      <tr>
                                        <td colSpan="2"><strong>Category Name</strong></td>
                                        <td><strong>Test Names</strong></td>
                                      </tr>
                                      {pitems.lab_tests?.map((psubitems, subIndex) => (
                                        <tr key={`lab-test-${psubitems.id || subIndex}`}>
                                          <td colSpan="2">{psubitems.category_name || "N/A"}</td>
                                          <td colSpan="2">{psubitems.test_name || "N/A"}</td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ))}
                                </>
                              )}

                              {/* ✅ Slot Date & Time shown at the end */}
                              <tr>
                                <td colSpan="5">
                                  <strong>Slot:</strong>{" "}
                                  {OrderInf?.slot_date ? `${OrderInf.slot_date} at ${OrderInf.slot_time}` : "N/A"}
                                </td>
                              </tr>
                            </tbody>


                          </table>
                        </div>
                      </div>




                      <div className="row-cont addmore-fileupload" >
                        {visitTypeIds.includes(1) && (
                          <div className="half-cont" >
                            <h2 className="fileupload-heading">Upload Files At-Home</h2>
                            {AddMoreFiles.map((test, index) => (
                              <>
                                <div className="addmoreset" key={test.id}>
                                  <div className='upload-img-cont'>
                                    <label>Upload File <span className="text-danger">*</span></label>
                                    <input
                                      type="file"
                                      accept="*"
                                      onChange={(e) => handleImageChange(e, index)}
                                      className="form-control"
                                    />
                                    <small className="text-secondary">Recommended size: <b>300 × 300 px</b></small>

                                  </div>
                                  <div className="action-icon">
                                    <Button
                                      type="text"
                                      icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                                      onClick={handleAddTest}
                                    />
                                  </div>
                                  <div className="action-icon">
                                    <Button
                                      type="text"
                                      icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                      onClick={() => handleRemoveTest(index)}
                                      disabled={AddMoreFiles.length === 1} // Prevent removing the last test
                                    />
                                  </div>
                                </div>

                              </>
                            ))}

                            {OrderInf?.athome?.length > 0 ? (
                              OrderInf.athome.map((file, index) => {
                                const fileName = file.document_name.replace("uploads/labdepartment/", ""); // ✅ Corrected variable name
                                return (

                                  <div className="addmoreset" key={index}>
                                    <div className="file-list">
                                      <span>{fileName}</span> {/* ✅ Show only file name */}
                                      <div className="down-btns">
                                        <Button
                                          className="view-btn"
                                          type="text"
                                          onClick={() => window.open(authService.getApiDomainUrl() + file.document_name, "_blank")}
                                        >
                                          View
                                        </Button>

                                        <Button
                                          type="text"
                                          icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                          onClick={() => handleDeleteFile(file.id)}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                );
                              })
                            ) : (
                              <p></p>
                            )}

                            <div className="submit-section">
                              <button className="btn btn-primary submit-btn" type="button" onClick={(event) => handleSubmit(event, 1)}>
                                Update
                              </button>
                            </div>
                          </div>
                        )}

                        {visitTypeIds.includes(2) && (
                          <div className="half-cont">
                            <h2 className="fileupload-heading">Upload Files At-Laboratory</h2>

                            {AddMoreFilesLab.map((test, index) => (
                              <div className="addmoreset" key={test.id}>
                                <div className="upload-img-cont">
                                  <label>
                                    Upload File <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="file"
                                    accept="*"
                                    onChange={(e) => handleImageChangeLab(e, index)}
                                    className="form-control"
                                  />
                                  <small className="text-secondary">
                                    Recommended size: <b>300 × 300 px</b>
                                  </small>
                                </div>

                                <div className="action-icon">
                                  <Button
                                    type="text"
                                    icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                                    onClick={handleAddTestLab}
                                  />
                                </div>

                                <div className="action-icon">
                                  <Button
                                    type="text"
                                    icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                    onClick={() => handleRemoveTestLab(index)}
                                    disabled={AddMoreFilesLab.length === 1} // Prevent removing the last test
                                  />
                                </div>
                              </div>
                            ))}

                            {OrderInf?.atlab?.length > 0 ? (
                              OrderInf.atlab.map((file, index) => {
                                const fileName = file.document_name.replace("uploads/labdepartment/", "");

                                return (
                                  <div className="addmoreset" key={index}>
                                    <div className="file-list">
                                      <span>{fileName}</span> {/* Show only file name */}
                                      <div className="down-btns">
                                        <Button
                                          className="view-btn"
                                          type="text"
                                          onClick={() => window.open(authService.getApiDomainUrl() + file.document_name, "_blank")}
                                        >
                                          View
                                        </Button>

                                        <Button
                                          type="text"
                                          icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                          onClick={() => handleDeleteFileLab(file.id)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : null}

                            <div className="submit-section">
                              <button className="btn btn-primary submit-btn" type="button" onClick={(event) => handleSubmit(event, 2)}>
                                Update
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryLabUploadFile;
